import React from 'react';
import { Button, Form, InputNumber, Modal, Select } from 'antd';
import { dateToString } from '../../../utils';

const { Option } = Select;

function WarrantyFormModal(props) {
	const { visible, onOk, onCancel, form } = props;
	const { getFieldDecorator, validateFields, resetFields } = form;

	const handleOk = () => {
		validateFields((err, values) => {
			if (!err) {
				onOk(values);
				resetFields();
			}
		});
	};

	const formattedDate = props.endDate
		? dateToString(props.endDate, 'DD-MM-YYYY')
		: 'Không có dữ liệu';

	return React.createElement(
		Modal,
		{
			title: 'Cập nhật phiếu bảo hành',
			visible: visible,
			onCancel: onCancel,
			footer: [
				React.createElement(
					Button,
					{ key: 'cancel', onClick: onCancel },
					'Bỏ qua'
				),
				React.createElement(
					Button,
					{ key: 'submit', type: 'primary', onClick: handleOk },
					'Xác nhận'
				)
			]
		},
		React.createElement(
			Form,
			null,
			// Kỳ hạn bảo hành (gồm số và đơn vị)
			React.createElement(
				Form.Item,
				{
					label: 'Kỳ hạn bảo hành',
					required: true,
					style: { marginBottom: 0 }
				},
				[
					React.createElement(
						Form.Item,
						{
							style: { display: 'inline-block', width: 'calc(70% - 8px)' },
							key: 'warrantyTime'
						},
						getFieldDecorator('warrantyTime', {
							initialValue: 24,
							rules: [{ required: true, message: 'Vui lòng nhập kỳ hạn' }]
						})(
							React.createElement(InputNumber, {
								min: 1,
								style: { width: '100%' }
							})
						)
					),
					React.createElement(
						Form.Item,
						{
							style: { display: 'inline-block', width: '30%', marginLeft: 8 },
							key: 'durationUnit'
						},
						getFieldDecorator('durationUnit', {
							initialValue: 'MONTH'
						})(
							React.createElement(
								Select,
								null,
								[
									React.createElement(Option, { value: 'DAY', key: 'DAY' }, 'Ngày'),
									React.createElement(Option, { value: 'WEEK', key: 'WEEK' }, 'Tuần'),
									React.createElement(Option, { value: 'MONTH', key: 'MONTH' }, 'Tháng'),
									React.createElement(Option, { value: 'QUARTER', key: 'QUARTER' }, 'Quý'),
									React.createElement(Option, { value: 'YEAR', key: 'YEAR' }, 'Năm')
								]
							)
						)
					)
				]
			),
			// Ngày kết thúc
			React.createElement(
				'div',
				{ style: { marginBottom: 16 } },
				React.createElement('label', {
					style: {
						display: 'block',
						marginBottom: 4
					}
				}, `Ngày kết thúc: ${formattedDate}`)
			)
		)
	);
}

const WrappedWarrantyFormModal = Form.create()(WarrantyFormModal);
export default WrappedWarrantyFormModal;
